import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    importExcel_btn: 'Импортировать',
    importExcel_title_contingents: 'Импорт контингента из Excel',
    importExcel_title_staff: 'Импорт сотрудников из Excel',
    importExcel_finished: 'Импорт завершён',
    importExcel_templateName_contingents: 'Шаблон импорта контингента',
    importExcel_templateName_staff: 'Шаблон импорта сотрудников',
    importExcel_templateTitle: 'Шаблон для заполнения',
    importExcel_templateHint: 'Первая строка — заголовки колонок, их не менять',
    importExcel_downloadTemplate: 'Скачать шаблон',
    importExcel_organization: 'Организация',
    importExcel_organizationSearch: 'поиск по реестру услугодателей',
    importExcel_clearOrganization: 'Сбросить организацию',
    importExcel_changeOrganization: 'Изменить организацию',
    importExcel_columnId: 'Номер',
    importExcel_bin: 'БИН',
    importExcel_columnName: 'Наименование',
    importExcel_columnIin: 'ИИН',
    importExcel_total: 'Всего',
    importExcel_rowHint: 'клик по строке выбирает организацию',
    importExcel_page: 'Стр. {{page}} из {{pages}}',
    importExcel_perPage: 'по 20',
    importExcel_prevPage: 'Предыдущая страница',
    importExcel_nextPage: 'Следующая страница',
    importExcel_organizationsError: 'Не удалось загрузить список организаций',
    importExcel_organizationsEmpty: 'Организации не найдены',
    importExcel_retry: 'Повторить',
    importExcel_selectOrganizationFirst: 'Сначала выберите организацию',
    importExcel_selectOrganizationHint: 'Затем станет доступна загрузка файла',
    importExcel_dropHint: 'Перетащите файл сюда или',
    importExcel_chooseFile: 'Выбрать файл',
    importExcel_formats: 'Форматы .xlsx, .xls · до 10 МБ · один файл',
    importExcel_formatError: 'Допустимы только файлы формата .xlsx, .xls',
    importExcel_sizeError: 'Размер файла не должен превышать 10 МБ',
    importExcel_emptyError: 'Файл пустой',
    importExcel_removeFile: 'Удалить файл',
    importExcel_cancel: 'Отмена',
    importExcel_upload: 'Загрузить',
    importExcel_uploading: 'Загрузка…',
    importExcel_sending: 'Отправка файла',
    importExcel_processing: 'Идёт обработка файла…',
    importExcel_processingHint: 'Не закрывайте окно до завершения. Проверяются ИИН, справочники и дубликаты.',
    importExcel_totalRows: 'Всего строк',
    importExcel_imported: 'Загружено',
    importExcel_failed: 'С ошибками',
    importExcel_errors: 'Ошибки',
    importExcel_downloadReport: 'Скачать отчёт об ошибках (.xlsx)',
    importExcel_reportName: 'Отчёт об ошибках импорта',
    importExcel_columnRow: 'Строка',
    importExcel_columnField: 'Поле',
    importExcel_columnError: 'Ошибка',
    importExcel_uploadAnother: 'Загрузить другой файл',
    importExcel_close: 'Закрыть',
    importExcel_error: 'Ошибка при импорте файла'
  },
  kk: {
    importExcel_btn: 'Импорттау',
    importExcel_title_contingents: 'Контингентті Excel-ден импорттау',
    importExcel_title_staff: 'Қызметкерлерді Excel-ден импорттау',
    importExcel_finished: 'Импорт аяқталды',
    importExcel_templateName_contingents: 'Контингентті импорттау үлгісі',
    importExcel_templateName_staff: 'Қызметкерлерді импорттау үлгісі',
    importExcel_templateTitle: 'Толтыруға арналған үлгі',
    importExcel_templateHint: 'Бірінші жол — бағандардың тақырыптары, оларды өзгертпеңіз',
    importExcel_downloadTemplate: 'Үлгіні жүктеп алу',
    importExcel_organization: 'Ұйым',
    importExcel_organizationSearch: 'қызмет берушілер тізілімі бойынша іздеу',
    importExcel_clearOrganization: 'Ұйымды тазалау',
    importExcel_changeOrganization: 'Ұйымды өзгерту',
    importExcel_columnId: 'Нөмірі',
    importExcel_bin: 'БСН',
    importExcel_columnName: 'Атауы',
    importExcel_columnIin: 'ЖСН',
    importExcel_total: 'Барлығы',
    importExcel_rowHint: 'ұйымды таңдау үшін жолды басыңыз',
    importExcel_page: '{{page}} / {{pages}} бет',
    importExcel_perPage: '20-дан',
    importExcel_prevPage: 'Алдыңғы бет',
    importExcel_nextPage: 'Келесі бет',
    importExcel_organizationsError: 'Ұйымдар тізімін жүктеу мүмкін болмады',
    importExcel_organizationsEmpty: 'Ұйымдар табылмады',
    importExcel_retry: 'Қайталау',
    importExcel_selectOrganizationFirst: 'Алдымен ұйымды таңдаңыз',
    importExcel_selectOrganizationHint: 'Содан кейін файлды жүктеу қолжетімді болады',
    importExcel_dropHint: 'Файлды осы жерге сүйреңіз немесе',
    importExcel_chooseFile: 'Файлды таңдау',
    importExcel_formats: '.xlsx, .xls форматтары · 10 МБ-қа дейін · бір файл',
    importExcel_formatError: 'Тек .xlsx, .xls форматындағы файлдарға рұқсат етіледі',
    importExcel_sizeError: 'Файл көлемі 10 МБ-тан аспауы керек',
    importExcel_emptyError: 'Файл бос',
    importExcel_removeFile: 'Файлды жою',
    importExcel_cancel: 'Болдырмау',
    importExcel_upload: 'Жүктеу',
    importExcel_uploading: 'Жүктелуде…',
    importExcel_sending: 'Файлды жіберу',
    importExcel_processing: 'Файл өңделуде…',
    importExcel_processingHint: 'Аяқталғанша терезені жаппаңыз. ЖСН, анықтамалықтар және қайталанулар тексерілуде.',
    importExcel_totalRows: 'Барлық жолдар',
    importExcel_imported: 'Жүктелді',
    importExcel_failed: 'Қателері бар',
    importExcel_errors: 'Қателер',
    importExcel_downloadReport: 'Қателер туралы есепті жүктеп алу (.xlsx)',
    importExcel_reportName: 'Импорт қателері туралы есеп',
    importExcel_columnRow: 'Жол',
    importExcel_columnField: 'Өріс',
    importExcel_columnError: 'Қате',
    importExcel_uploadAnother: 'Басқа файлды жүктеу',
    importExcel_close: 'Жабу',
    importExcel_error: 'Файлды импорттау кезінде қате'
  }
});
